import(/* webpackMode: "eager", webpackExports: ["PackageManagerSnippetProvider"] */ "/opt/build/repo/docs/src/blocks/PackageManagerSnippet/PackageManagerSnippetProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeComponentsProvider"] */ "/opt/build/repo/docs/src/code-components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/opt/build/repo/docs/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchControls"] */ "/opt/build/repo/docs/src/components/SearchControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Section","Heading","List","Item","Badge","Separator"] */ "/opt/build/repo/docs/src/components/SideNav.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/index.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/layout.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/SkipNav.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Header.css");
;
import(/* webpackMode: "eager", webpackExports: ["useTypesDataContext"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.48_@types+react@19.3.0_next@16.3.5_@babel+core@7_6b77edc5348bc99e031b411b0d161f8d/node_modules/@mui/internal-docs-infra/useType/TypesDataContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TypesDataProvider"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.48_@types+react@19.3.0_next@16.3.5_@babel+core@7_6b77edc5348bc99e031b411b0d161f8d/node_modules/@mui/internal-docs-infra/useType/TypesDataProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useType"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.48_@types+react@19.3.0_next@16.3.5_@babel+core@7_6b77edc5348bc99e031b411b0d161f8d/node_modules/@mui/internal-docs-infra/useType/useType.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useTypeProp"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.48_@types+react@19.3.0_next@16.3.5_@babel+core@7_6b77edc5348bc99e031b411b0d161f8d/node_modules/@mui/internal-docs-infra/useType/useTypeProp.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.3.5_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.62.1_@types+no_d2fdbd8810242c74af815da29b1fb3ef/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipArrow"] */ "/opt/build/repo/packages/react/src/tooltip/arrow/TooltipArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPopup"] */ "/opt/build/repo/packages/react/src/tooltip/popup/TooltipPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPortal"] */ "/opt/build/repo/packages/react/src/tooltip/portal/TooltipPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPositioner"] */ "/opt/build/repo/packages/react/src/tooltip/positioner/TooltipPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/opt/build/repo/packages/react/src/tooltip/provider/TooltipProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipRoot"] */ "/opt/build/repo/packages/react/src/tooltip/root/TooltipRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipTrigger"] */ "/opt/build/repo/packages/react/src/tooltip/trigger/TooltipTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipViewport"] */ "/opt/build/repo/packages/react/src/tooltip/viewport/TooltipViewport.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/popupStoreUtils.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/usePopupHandleStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/ReactStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/StoreInspector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useAnimationFrame.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRefWithInit"] */ "/opt/build/repo/packages/utils/src/useRefWithInit.ts");
